/**
 * Utility to extract a user-friendly error message from API error responses.
 * Handles Pydantic v2 validation errors (array of objects) and standard string errors.
 * 
 * @param {Object} err - The error object from axios catch
 * @param {string} fallback - Fallback message if no specific error is found
 * @returns {string} User-friendly error message
 */
export const getErrorMessage = (err, fallback = 'An error occurred. Please try again.') => {
  const errorDetail = err?.response?.data?.detail;
  
  if (!errorDetail) {
    return fallback;
  }
  
  // Pydantic v2 validation error format: [{type, loc, msg, input, url}, ...]
  if (Array.isArray(errorDetail)) {
    return errorDetail
      .map(e => e.msg || e.message || 'Validation error')
      .join('. ');
  }
  
  // Single object error
  if (typeof errorDetail === 'object' && errorDetail !== null) {
    return errorDetail.msg || errorDetail.message || fallback;
  }
  
  // String error
  return errorDetail;
};

export default getErrorMessage;
